/* eslint-disable valid-typeof */
interface WindowProps {
  [key: string]: any;
}
export const getMobileOperatingSystem = () => {
  if (typeof window === undefined) {
    return 'customWindow';
  }
  const customWindow: WindowProps = window;
  const userAgent = navigator.userAgent || navigator.vendor || customWindow.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }
  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !customWindow.MSStream) {
    return 'iOS';
  }

  return 'desktop';
};

export const checkIsSafari = () => {
  if (typeof window === undefined) {
    return false;
  }
  const isSafari = /constructor/i.test((window as any).HTMLElement)
    || (function (p) {
      return p.toString() === '[object SafariRemoteNotification]';
    }(
      !(window as any).safari
        || (typeof (window as any).safari !== 'undefined' && (window as any).safari.pushNotification),
    ));
  return isSafari;
};
